export default {
  // report
  REPORT: {
    chapter: {
      ___appendix: '付録',
      title: {
        ___subject: '基本項目',
        ___subject_TPO: '報告書カバーページ（患者情報）',
        ___findings_TPO: '所見',
        ___intractable_disease: 'D006-4 指定難病の遺伝学的検査',
        ___disease_diagnosis: '解析結果',
        ___disease_diagnosis_TPO: '結果',
        ___active_screening: 'プロアクティブ・テスト',
        ___cause_screening: 'キャリア・スクリーニング',
        ___acmg_incidental: 'ACMG Incidental',
        ___custom1: 'custom1',
        ___custom2: 'custom2',
        ___custom3: 'custom3',
        ___constitution: '体質関連遺伝子',
        ___drug_meta: '薬理遺伝学',
        ___method: '検査方法',
        ___method_TPO: '検査方法、検査品質および解析ソフト',
        ___appendix_intractable_disease_list: 'D006_4 遺傳子リスト',
        ___appendix_disease_gene: '解析結果に含まれる遺伝子リスト',
        ___appendix_disease_gene_ID: '症状絞り込みのための遺伝子リスト',
        ___appendix_disease_gene_TPO: '遺伝子リスト',
        ___appendix_us_gene: 'ACMGガイドラインに含まれる遺伝子リスト'
      },
      item: {
        title: {
          ___resultSummary: '結果一覧',
          ___interpretation: '注釈'
        }
      },
      header: {
        ___info01: '報告日',
        ___info02: 'サンプルID',
        ___infoTPO01: 'Sample ID'
      },
      footer: {
        ___info01: '＊この報告書は、医療専門家による解釈が必要です。',
        ___infoRuo01: '＊この報告は、専門の医療関係者向けの参考情報としてのみお使いください。',
        ___infoSaitama01: '＊この報告書は、遺伝専門医による解釈が必要です。',
        ___info02: '〒162-0056 東京都新宿区若松町 2-2 TWIns 先端生命医科学研究教育施設 3 階 N102 | COMPASS株式会社 | supportjp@compassbioinfo.com',
        ___infoSaitama02: '〒362-0806 埼玉県北足立郡伊奈町小室 780 | 埼玉県立がんセンター 遺伝科 | g.idenshi02@saitama-pho.jp'
      },
      basicInfo: {
        ___title: '検査結果報告書<br>基本項目',
        ___signTitle: '署名',
        ___signTitle_Saitama: '説明担当者署名',
        form: {
          title: {
            ___case_id: '患者氏名',
            ___case_id_ID: '匿名化番号',
            ___sex: '性別',
            ___age: '年齢',
            ___testing_date: '測定日',
            ___testing_date_ID: '検査日',
            ___testing_category: 'サンプル',
            ___sequencing_range: '検査方法',
            ___sequencing_tech: '使用機器',
            ___doctor_name: '医師',
            ___doctor_name_ID: '依賴医',
            ___doctor_name_Saitama: '依頼医師',
            ___organization: '施設名',
            ___organization_ID: '依頼機関名',
            ___medical_number: '症例ID',
            ___disclaimer_Saitama: '免責事項',
            ___family_medical_history: '備考'
          }
        }
      },
      basicInfoTPO: {
        ___title: '溶血性貧血関連遺伝子検査<br>報告書',
        ___signTitle: '署名',
        form: {
          title: {
            ___case_id: '匿名化番号',
            ___birthday: '生年月日',
            ___sex: '性別',
            ___testing_date: '検体受取日',
            ___report_date: '結果報告日',
            ___organization: '依頼機関名・診療科',
            ___doctor_name: '依頼医師名'
          },
          birthdayInfo: {
            ___years: '{count}歳',
            ___month: '{count}か月',
            ___day: '日齢{count}日'
          }
        },
        info: {
          ___content01: '遺伝子検査には一定の検出限界があることをご理解くださいまたSanger法でのre-sequenceは行っておりません',
          ___content02: '解析は臨床研究目的のもので、診療に供するものではありません',
          ___content03: '最終診断につきましては、臨床像、他の検査結果と併せて総合的に判断をお願い致します',
          ___content04: 'この結果を公表する時は、事前にご一報(info@anemia-support.org)頂けますと幸いです'
        }
      },
      findingsTPO: {
        ___title: '所見',
        ___placeholder: '結果に対するコメントを入力する',
        footer: {
          ___info01: 'NPO法人 血液難病診療サポート',
          ___info02: '(東京女子医科大学内)',
          ___info03: '菅野 仁',
          ___info04: '小倉 浩美'
        }
      },
      variantResult: {
        mainData: {
          ___saitamaEmpty: '報告対象となる遺伝子の変化は検出されませんでした。',
          default: {
            ___title: '注釈',
            ___contentTitle01_01: '疾患を引き起こす可能性のある変異を含む遺伝子が<b> {count} </b>個検出され、',
            ___contentTitle01_02: '疾患を引き起こす可能性のある変異を含む遺伝子が<b> {count} </b>個検出されました。',
            ___contentTitle02: 'そのうちミトコンドリアに存在する遺伝子は<b> {count} </b>個でした。',
            detail: {
              title: {
                ___ClinVar: 'ClinVarの臨床解釈は{result}です。',
                ___ClinVar_empty: 'ClinVarに情報がありません。',
                ___ACMG: 'ACMGの分類は{result}です。',
                ___OMIM: 'OMIMでは次のような関連疾患が見つかりました。',
                ___OMIM_empty: 'OMIMでは遺伝子関連疾患は見つかりませんでした。',
                ___Orphanet: 'Orphanetでは次のような関連疾患が見つかりました。',
                ___Orphanet_empty: 'Orphanetでは遺伝子関連疾患は見つかりませんでした。'
              }
            }
          },
          cnv: {
            ___title: 'CNV注釈',
            ___contentTitle01: '遺伝子検査により、原因となる可能性のある変異を持つ領域が計 <b>{count}</b> 個特定されました。',
            detail: {
              title: {
                ___genes: 'この領域内の影響を受ける遺伝子は{result}です。',
                ___OMIM: 'OMIMでは次のような関連疾患が見つかりました。',
                ___OMIM_empty: 'OMIMでは遺伝子関連疾患は見つかりませんでした。'
              }
            }
          }
        }
      },
      variantDetail: {
        ___symbolContainerTitle: '結果一覧',
        ___variantContainerTitle: '関連する疾患と表現型',
        ___phenotypeTableEmpty: 'データなし',
        ___variantNotePlaceholder: '備考',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVarデータベース',
            ___ACMG: 'ACMGガイドライン',
            ___SIFT_PolyPhen: 'SIFT / PolyPhen-2',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT: 'Homoplasmy EAS AF / Heteroplasmy EAS AF',
            ___AF: 'TW Biobank / gnomAD EAS',
            ___AF_EN: 'GnomAD Exomes AF / GnomAD Genomes AF',
            ___AF_JP: 'GnomAD Genomes AF / ToMMo 60K JPN',
            ___Population_Databases: '集団データベース',
            ___Prediction_Score: 'タンパク質の機能予測',
            ___Sequencing_Quality: 'シーケンス品質'
          }
        },
        info: {
          title: {
            ___phenotypes: '表現型',
            ___gene_panels: '遺伝子パネル',
            ___related_genes: '遺伝子'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_details_pos: '位置<br>(HG38)',
            ___custom_details_Rank: 'エクソン/イントロン',
            ___custom_details_Rank_Saitama: 'エクソン ( イントロン ) 位置 / 全エクソン ( イントロン )',
            ___custom_details_HGVSm: 'HGVSm',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT_AF: 'Heteroplasmy<br>Level (%)',
            ___custom_details_GT: '接合性',
            ___custom_details_Consequence: '変異タイプ',
            ___custom_details_Consequence_Saitama: 'バリアントタイプ',
            ___custom_details_dbSNP_ID: 'rs ID',
            ___custom_parental_origin: '親の起源',
            ___custom_parental_origin_Saitama: '遺伝伝達<br>（父 / 母）'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        },
        dbTable: {
          title: {
            ___KG_AF: '1000 Genomes',
            ___KG_EAS_AF: '1000 Genomes EAS',
            ___gnomAD_AF: 'GnomAD Exomes',
            ___gnomAD_g_AF: 'GnomAD Genomes',
            ___gnomAD_g_AF_eas: 'GnomAD Genomes<br>EAS',
            ___TW_AF: 'TW Biobank',
            ___TOPMED_AF: 'TOPMED',
            ___UK10K_AF: 'UK10K',
            ___GA_AF: 'Genome Asia100',
            ___tommo_60kjpn_AF: 'ToMMo 60K JPN',
            ___gnomAD_g_mt_AF_het: 'GnomAD Genomes<br>Heteroplasmy',
            ___gnomAD_g_mt_pop_AF_het_eas: 'GnomAD Genomes<br>Heteroplasmy EAS',
            ___gnomAD_g_mt_AF_hom: 'GnomAD Genomes<br>Homoplasmy',
            ___gnomAD_g_mt_pop_AF_hom_eas: 'GnomAD Genomes<br>Homoplasmy EAS'
          }
        },
        psTable: {
          title: {
            ___SIFT4G: 'SIFT4G',
            ___FATHMM: 'FATHMM',
            ___PROVEAN: 'PROVEAN',
            ___MetaLR: 'MetaLR',
            ___MetaSVM: 'MetaSVM',
            ___BayesDel_noAF: 'BayesDel noAF',
            ___gnomAD_g_mt_mitotip: 'MitoTip',
            ___ada: 'ada',
            ___rf: 'rf',
            ___GERPpp_RS: 'GERP++RS',
            ___SiPhy_29way_logOdds: 'SiPhy 29way logOdds'
          }
        }
      },
      variantDetailTPO: {
        ___title: '結果',
        ___chapterMainInfo: 'A.疾患を引き起こす可能性を含む遺伝子変化が<b>{count}</b>個検出されました | A.疾患を引き起こす可能性を含む遺伝子変化が<b>{count}</b>個検出されました（A-1～A-{count}）',
        ___variantContainerNumber: 'A-{count}.',
        ___variantContainerTitle: '[関連する疾患と表現型]',
        ___variantContainerContent: '<b>{symbol}</b> 遺伝子変異によって引き起こされる関連疾患には以下のものがあります',
        ___phenotypeTableEmpty: 'データなし',
        variantSubBlock: {
          title: {
            ___ClinVar: 'ClinVar Database',
            ___ACMG: 'ACMG/AMP 2015 Guideline',
            ___SIFT: 'SIFT',
            ___PolyPhen: 'PolyPhen-2',
            ___CADD: 'CADD',
            ___AF_MT1: 'Homoplasmy EAS AF',
            ___AF_MT2: 'Heteroplasmy EAS AF',
            ___AF_JP1: 'ToMMo 60K JPN',
            ___AF_JP2: 'gnomAD EAS'
          }
        },
        portraitVariantTable: {
          title: {
            ___custom_gene: 'Gene',
            ___custom_details_pos: 'Position',
            ___custom_details_Rank: 'エクソン/イントロン',
            ___custom_details_HGVSc: 'HGVSc',
            ___custom_details_HGVSp: 'HGVSp',
            ___custom_details_GT: '接合型',
            ___custom_details_OMIM: 'OMIM',
            ___custom_details_Consequence: 'Function',
            ___custom_details_dbSNP_ID: 'rs ID'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      variantCNV: {
        ___mainTableTitle: 'CNV 結果一覧',
        ___symbolContainerTitle: '関連遺伝子',
        ___geneContainerTitle: '関連する疾患と表現型',
        ___phenotypeTableEmpty: 'データなし',
        ___cnvNotePlaceholder: '備考',
        cnvTable: {
          title: {
            ___Position: '位置',
            ___Exon_Intron: 'エクソン/イントロン',
            ___Zygosity: '接合性',
            ___Consequence: '変異タイプ',
            ___Fragment_size: 'フラグメントサイズ',
            ___Parental_Origin: '親の起源'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      variantCNVTPO: {
        ___title: '結果',
        ___chapterMainInfo: 'B.疾患を引き起こす可能性を含むCNVの領域が<b>{count}</b>個検出されました | B.疾患を引き起こす可能性を含むCNVの領域が<b>{count}</b>個検出されました（1.～{count}.）',
        ___geneContainerNumber: 'B-{count}.',
        ___geneContainerTitle: '関連する疾患と表現型',
        ___geneContainerContent: '<b>{symbol}</b>遺伝子変異によって引き起こされる関連疾患には以下のものがあります',
        ___phenotypeTableEmpty: 'データなし',
        cnvTable: {
          title: {
            ___Position: 'Position',
            ___Exon_Intron: 'エクソン/イントロン',
            ___Zygosity: '接合性',
            ___Consequence: '変異タイプ',
            ___Fragment_size: 'フラグメントサイズ',
            ___Parental_Origin: '親の起源'
          }
        },
        phenotypeTable: {
          title: {
            ___Phenotype: '表現型',
            ___id: 'OMIM番号',
            ___Inheritance: '遺伝形式'
          }
        },
        phenotypeMTTable: {
          title: {
            ___disease: '表現型',
            ___id: 'ORPHA番号'
          }
        }
      },
      intractableDiseaseResult: {
        ___title: 'D006-4 指定難病の遺伝学的検査',
        diseaseList: {
          ___title: '指定難病'
        },
        diseaseRange: {
          ___title: '遺伝子の範囲',
          content: {
            ___list: '<b>{name}</b>に関連する遺伝子を対象として、{count}個の遺伝子に対する関連性解析をすでに実施しております。',
            ___suffix: '詳細は別添の「D006-4 遺伝子リスト」をご参照ください。'
          }
        }
      },
      constitutionGene: {
        ___title: '体質関連遺伝子',
        ___subTitle: '多くの遺伝子がアレルギー、血栓、アルコール不耐症に関連していることが明らかになっています。この重要な情報は、生活における予防策を提供します。',
        ___subTitleSaitama: '<b>検出基準：</b><br>シーケンスの深度DP≧10、クオリティGQ≧20<br><b>遺伝子型判定：</b><br>アリル頻度が≧0.9の場合、ホモ接合<br>アリル頻度が0.25〜0.75の場合、ヘテロ接合と判定されます。<br>上記以外の場合(<0.25または0.75〜0.9)には品質フィルタの基準を満たさないため「未検出(0/0)」として判定 されます。',
        mainData: {
          testSummary: {
            ___title: '検査結果の説明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '各種検査項目'
          }
        },
        table: {
          title: {
            ___title: '検査項目',
            ___SYMBOL: '遺伝子',
            ___Location2: '位置',
            ___Result: '結果'
          },
          value: {
            Result: {
              ___true: '検出',
              ___false: '未検出'
            }
          }
        }
      },
      drugAnalysis: {
        ___title: '薬理遺伝学',
        ___subTitle: '薬理遺伝学は、重篤な副作用や毒性を防ぎ、最適な治療反応を達成するために、個人に最適な薬剤を選択するための参考情報を提供します。同じ薬でも、個人によっては重篤なアレルギーや副作用の増強が発生する可能性があり、それは、不適切な薬や用量を使用したことが原因であると考えられます。',
        ___subTitleSaitama: '<b>検出基準：</b><br>シーケンスの深度DP≧10、クオリティGQ≧20<br><b>遺伝子型判定：</b><br>アリル頻度が≧0.9の場合、ホモ接合<br>アリル頻度が0.25〜0.75の場合、ヘテロ接合と判定されます。<br>上記以外の場合(<0.25または0.75〜0.9)には品質フィルタの基準を満たさないため「未検出(0/0)」として判定 されます。',
        customInfos: {
          ___info01: '＊ 赤で示された遺伝子型は、検出されたリスク遺伝子型を示しています。'
        },
        mainData: {
          testSummary: {
            ___title: '検査結果の説明'
          }
        },
        mainTable: {
          testingItems: {
            ___title: '各種検査項目'
          }
        },
        table: {
          title: {
            ___name: '薬剤名',
            ___type: '効果',
            ___SYMBOL: '遺伝子',
            ___risk_genotype2: '位置',
            ___clinical_phenotype: '説明',
            ___Result: '結果'
          },
          value: {
            Result: {
              ___true: '検出',
              ___false: '未検出'
            }
          }
        }
      },
      detectMethod: {
        ___title: '検査およびシーケンス品質に関する情報',
        ___subTitle: '検査方法の説明',
        table: {
          title: {
            ___library_kit: 'ライブラリー作成キット',
            ___sequencing_platform: 'シーケンス・プラットフォーム',
            ___sequencing_length: 'リード長',
            ___average_sequencing_length: 'リード深度',
            ___pct_target_bases_xx: '標的領域の10/20Xカバレッジ',
            ___reference: 'リファレンスゲノム',
            ___alignment_version: 'アライメントソフトウェア',
            ___variant_calling_version: 'バリアントコーリングソフトウェア',
            ___jannovar_version: 'バリアントアノテーションソフトウェアjANNOVAR',
            ___vep_version: 'バリアントアノテーションソフトウェア VEP',
            ___hpo_version: 'HPOバージョン',
            ___omim_version: 'OMIMバージョン',
            ___dbsnp_version: 'dbSNPバージョン',
            ___clinvar_version: 'ClinVarバージョン',
            ___mitomap_version: 'MITOMAPバージョン',
            ___dbnsfp_version: 'dbNSFPバージョン',
            ___gene_panel_version_TPO: '遺伝子パネル',
            ___report_version_TPO: 'Report version'
          }
        }
      },
      detectMethodTPO: {
        ___title: '検査方法、検査品質および解析ソフト',
        ___subTitle: '検査方法の説明',
        table: {
          title: {
            ___library_kit: 'Library kit',
            ___sequencing_platform: 'Sequence platform',
            ___sequencing_length: 'Read length',
            ___average_sequencing_length: 'Read depth',
            ___pct_target_bases_xx: '20×Coverage of target region',
            ___reference: 'Reference genome',
            ___alignment_version: 'Alignment software',
            ___variant_calling_version: 'Variant calling software',
            ___jannovar_version: 'Variant annotation software<br>(jANNOVAR)',
            ___vep_version: 'Variant annotation software<br>(Variant Effect Predictor)',
            ___hpo_version: 'HPO version',
            ___omim_version: 'OMIM version',
            ___dbsnp_version: 'dbSNP version',
            ___clinvar_version: 'ClinVar version',
            ___dbnsfp_version: 'dbNSFP version'
          }
        }
      },
      detectMethodComment: {
        ___subTitle: '検査用語などの注釈',
        list: {
          list01: {
            ___title: 'この検査に使用された参照ゲノムはGRCh38（またはhg38）です。'
          },
          list02: {
            ___title: '<b>遺伝子型</b>',
            detail: {
              detail01: {
                ___title: 'ホモ接合性：ホモ接合性の遺伝子型には、2個の正常な対立遺伝子、または同じ変異を持つ2個の対立遺伝子が含まれる場合があります。'
              },
              detail02: {
                ___title: 'ヘテロ接合性：ヘテロ接合性の遺伝子型には、1個の正常対立遺伝子と1個の変異対立遺伝子、または2個の異なる変異対立遺伝子(複合ヘテロ接合)が含まれる場合があります。'
              },
              detail03: {
                ___title: 'ヘミ接合性：ある遺伝子を通常2コピー持つところを1コピーしか持たない人を表す用語です。ヘミ接合性はは正常な状態でも起こり得ます。例えば、ほとんどの男性はX染色体とY染色体を1本ずつ持っているため、これらの染色体上の遺伝子はヘミ接合性です。'
              }
            }
          },
          list03: {
            ___title: '<b>臨床的意義</b>：ClinVar データベースの解釈または ACMG (2015) 分類を参照してください。',
            detail: {
              detail01: {
                ___title: '病原性：ある遺伝子の変異が病原性です。'
              },
              detail02: {
                ___title: '病原性の可能性が高い：ある遺伝子の変異は病原性です可能性が高いです。'
              },
              detail03: {
                ___title: '重要性が不明：ある遺伝子の変異は重要性が不明です。'
              },
              detail04: {
                ___title: '良性です可能性が高い：ある遺伝子の変異は良性です可能性が高いです。'
              },
              detail05: {
                ___title: '良性：ある遺伝子の変異は良性です。'
              },
              detail06: {
                ___title: '病原性の解釈の対立：コンソーシアムからの提出に限り、コンソーシアム内のグループが変異について相反する解釈を持ちながら、ClinVarに単一の提出を行う場合です。'
              },
              detail07: {
                ___title: '疾患関連多型：特定の遺伝子の多型が疾患と関連していることが報告されています。'
              },
              detail08: {
                ___title: 'SNP：バリアントのアレル頻度は1000ゲノムで1％以上であり、関連する疾患は報告されていません。'
              },
              detail09: {
                ___title: '薬物反応：疾患ではなく、薬物反応に影響を及ぼすバリアントの総称です。'
              }
            }
          },
          list04: {
            ___title: '<b>参考資料</b>',
            detail: {
              detail01: {
                ___title: '1000 Genomes EAS：1000 Genomesプロジェクトの東アジア集団のアレル頻度です。'
              },
              detail02: {
                ___title: 'gnomAD EAS：gnomADプロジェクトの東アジア集団のアレル頻度です。'
              },
              detail03: {
                ___title: 'ToMMo 60k：東北メディカル・メガバンク機構（ToMMo）のアレル頻度です。'
              },
              detail04: {
                ___title: '参考文献：このバリアントが文献で報告されている場合、参考文献には筆頭著者、出版年、雑誌名、巻数、開始ページが記載されます。'
              },
              detail05: {
                ___title: 'SIFTとPolyPhen-2は、アミノ酸変異の臨床的影響を予測するために使用される2つのツールです。SIFTでは、予測結果は 「有害」または「許容」と表記され、括弧内の数字は予測結果です。PolyPhen-2では、予測結果は「有害」、「有害の可能性あり」、「良性」と表記され、括弧内の数字は予測結果です。ただし、この予測結果はタンパク質やゲノム研究に関連するエビデンスを欠いており、予測された臨床的意義の正確性は確認できないため、あくまで参考までにご覧ください。'
              }
            }
          }
        }
      },
      detectMethodCommentTPO: {
        ___subTitle: '注釈',
        list: {
          list01: {
            ___title: '[検査の限界]<br>この検査も同様ですが、WESは単一の塩基の変異に対して高い感度を示しますが、小さな挿入‧欠失に対する感度は低く、Exon- Intron junctionから離れた変異、プロモーター領域の変異[TA1] [KY2] [KY3] 、大規模なExonの欠失や重複、およびその他の構造変異 [TA4] は検出が困難です'
          },
          list02: {
            ___title: '[臨床的意義の判定]ClinvardatabaseまたはACMG(2015)分類が判定基準',
            detail: {
              detail01: {
                ___title: 'Pathogenic: 変異は病原性がある'
              },
              detail02: {
                ___title: 'Likely pathogenic: 変異は病原性の可能性が高い'
              },
              detail03: {
                ___title: 'Uncertain significance: 変異の病原性は不明'
              },
              detail04: {
                ___title: 'Likely benign: 変異は良性の可能性が高い'
              },
              detail05: {
                ___title: 'Benign: 変異は良性である'
              }
            }
          },
          list03: {
            ___title: 'SIFTとPolyphen-2は変異がタンパク質に与える影響を予測するためのツールです。あくまでも予測ですので臨床的意義の正確性を保 証していません',
            detail: {
              detail01: {
                ___title: 'SIFTは<有害>D: Deleteriousまたは<許容>T: Tolerated'
              },
              detail02: {
                ___title: 'Polyphen-2は<有害>D: Probably damagingまたは<有害の可能性あり>P:Possibly damagingまたは<良性>B:Benignと表記され、 カッコ内の数字は予測結果です'
              }
            }
          },
          list04: {
            ___title: '[用語]',
            detail: {
              detail01: {
                ___title: '1000Genome EAS:1000Genomeプロジェクトの東アジア集団のアレル頻度'
              },
              detail02: {
                ___title: 'genomAD EAS: genomADプロジェクトの東アジア集団のアレル頻度'
              },
              detail03: {
                ___title: 'ToMMo 60K JPN: ToMMo 60K JPNのアレル頻度'
              }
            }
          }
        }
      },
      attachmentIntractableDiseaseDetail: {
        ___title: 'D006_4 遺傳子リスト',
        table: {
          title: {
            ___disease: 'D006-4 遺伝学的検査の疾患名',
            ___gene: '代表的な疾患原因遺伝子<br>(指定難病の診断基準の遺伝子)'
          }
        }
      },
      attachmentDiagnosisGene: {
        ___title: '解析結果に含まれる遺伝子リスト',
        ___title_ID: '症状絞り込みのための遺伝子リスト',
        ___geneListTitle01: '遺伝子のカバレッジ ≥ {cov}',
        ___geneListTitle02: '遺伝子のカバレッジ < {cov}'
      },
      attachmentDiagnosisGeneTPO: {
        ___title: '遺伝子リスト',
        ___info: '*HBA1は配列の特性から検出が困難な場合があります。',
        ___geneListTitle01: '遺伝子のCoverage ≥ {cov}',
        ___geneListTitle02: '遺伝子のCoverage < {cov}',
        footer: {
          ___info01: '[本検査の問い合わせ先]',
          ___info02: 'NPO法人血液難病診療サポート',
          ___info03: '（東京女子医科大学内）'
        }
      },
      attachmentASoHGGene: {
        ___title: 'ACMGガイドラインに含まれる遺伝子リスト'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/lang/_report/ja/lang.js